export default __webpack_public_path__ + "static/Rectangle-43615-72a6db8ed71897c14942c3470dc6f39a.png";